import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    canonical,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    ogType = 'website',
    twitterHandle = '@ahamhfc',
    robots = 'index, follow',
    schema
}) => {
    const siteTitle = "AHAM Housing Finance";
    const fullTitle = title ? `${title} ` : siteTitle;
    const siteUrl = "https://ahamhfc.com";

    return (
        <>
            <Helmet>
                {/* Standard Metadata */}
                <title key="title">{fullTitle}</title>
                <meta key="description" name="description" content={description} />
                <meta key="keywords" name="keywords" content={keywords} />
                <link key="canonical" rel="canonical" href={canonical || siteUrl} />
                <meta key="robots" name="robots" content={robots} />

                {/* Open Graph */}
                <meta key="og:type" property="og:type" content={ogType} />
                <meta key="og:url" property="og:url" content={canonical || siteUrl} />
                <meta key="og:title" property="og:title" content={ogTitle || fullTitle} />
                <meta key="og:description" property="og:description" content={ogDescription || description} />
                <meta key="og:image" property="og:image" content={ogImage || `${siteUrl}/img/logo/logo.png`} />

                {/* Twitter */}
                <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
                <meta key="twitter:site" name="twitter:site" content={twitterHandle} />
                <meta key="twitter:title" name="twitter:title" content={ogTitle || fullTitle} />
                <meta key="twitter:description" name="twitter:description" content={ogDescription || description} />
                <meta key="twitter:image" name="twitter:image" content={ogImage || `${siteUrl}/img/logo/logo.png`} />

                <meta key="author" name="author" content="AHAM Housing Finance" />
                <meta key="article:publisher" property="article:publisher" content="https://ahamhfc.com" />
            </Helmet>

            {/* Schema JSON-LD - Rendered outside of Helmet for better compatibility with SPA crawlers */}
            {(() => {
                if (!schema) return null;
                let schemaString = '';
                if (typeof schema === 'string') {
                    const trimmed = schema.trim();
                    if (!trimmed) return null;
                    const clean = trimmed
                        .replace(/^<script[^>]*>/i, '')
                        .replace(/<\/script>$/i, '')
                        .trim();
                    schemaString = clean;
                } else if (typeof schema === 'object') {
                    if (Array.isArray(schema)) {
                        if (schema.length === 0) return null;
                    } else if (Object.keys(schema).length === 0) {
                        return null;
                    }
                    schemaString = JSON.stringify(schema, null, 2);
                }
                if (!schemaString) return null;
                return (
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{ __html: schemaString }}
                    />
                );
            })()}
        </>
    );
};

export default SEO;